// disabling because string concatenation is faster
export const flattenClassNames = (classNames: (string | undefined)[]): string | undefined => {
  let result: string | undefined;

  // using traditional for loop because it is the fastest. This function will be used in a lot of places
  for (let i = 0; i < classNames.length; i += 1) {
    const className = classNames[i];
    if (className !== undefined) {
      result = result === undefined ? className : result + ' ' + className;
    }
  }

  return result;
};
